import {
  enablePointerEvents,
  disablePointerEvents,
} from '@utils/pointer-events-control';

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({ key: 'StartScene' });
  }

  preload() {}

  create() {
    enablePointerEvents();

    const r5 = this.add
      .rectangle(0, 0, 1280, 720, 0xffffff)
      .setOrigin(0)
      .setDepth(15)
      .setAlpha(0);

    this.anims.create({
      key: 'bub',
      frames: this.anims.generateFrameNames('bubbleOne', {
        start: 0,
        end: 93,
        zeroPad: 0,
        prefix: 'bubbleTypeOne',
        suffix: '.png',
      }),
      frameRate: 24,
      repeat: -1,
      repeatDelay: 7000,
    });

    this.anims.create({
      key: 'octo',
      frames: this.anims.generateFrameNames('octopusAnim', {
        start: 0,
        end: 49,
        zeroPad: 0,
        prefix: 'octopus',
        suffix: '.png',
      }),
      frameRate: 25,
      repeat: 0,
    });

    this.add.image(0, 0, 'sbg').setOrigin(0);

    this.bub3 = this.add.sprite(400, 0, 'bubbleOne').setOrigin(0).setAlpha(0).setScale(0.5);

    this.fish = this.add.image(1280, 148, 'fish').setOrigin(0);

    this.bub2 = this.add.sprite(800, 0, 'bubbleOne').setOrigin(0).setAlpha(0).setScale(0.7);

    this.tweens.add({
      targets: this.fish,
      x: -200,
      duration: 24000,
      repeat: -1,
      repeatDelay: 4000,
    });
    this.add.image(0, 0, 'sbg2').setOrigin(0);

    this.bub1 = this.add.sprite(0, 0, 'bubbleOne').setOrigin(0).setAlpha(0).setScale(0.8);

    this.octo = this.add.sprite(100, 360, 'octopusAnim').setOrigin(0).setScale(0.3);

    for (let i = 1; i < 10; i++) {
      this.tweens.add({
        targets: this.octo,
        ease: 'sine.easeIn',
        x: this.octo.x + 50 * i,
        y: this.octo.y - 100 * i,
        duration: 2000,
        delay: 2000 * (i - 1),
        onStart: () => {
          this.octo.play('octo');
        },
        onRepeat: () => {
          this.octo.play('octo');
        },
      });
    }

    this.add.image(0, 0, 'sbg3').setOrigin(0);

    this.weed = this.add.image(16, 385, 'weed').setOrigin(0);

    const postFxPlugin = this.plugins.get('rexwarppipelineplugin');
    if (postFxPlugin) {
      postFxPlugin.add(this.weed, {
        speedY: 0.5,
        frequencyX: 20,
        frequencyY: 20,
        amplitudeX: 1.5,
        amplitudeY: 1,
        speedX: 2,
      });
    }

    this.bub = this.add.sprite(0, 0, 'bubbleOne').setOrigin(0).setAlpha(0.8);

    this.bub.play('bub');
    this.time.delayedCall(2000, () => {
      this.bub2.play('bub');
      this.bub2.setAlpha(0.5);
    });

    this.time.delayedCall(5000, () => {
      this.bub1.play('bub');
      this.bub1.setAlpha(0.5);
    });

    this.time.delayedCall(7000, () => {
      this.bub3.play('bub');
      this.bub3.setAlpha(0.3);
    });

    this.playButton = this.add
      .image(536, 483, 'play_button')
      .setInteractive({ cursor: 'pointer' })
      .setOrigin(0, 0);

    this.gameName = this.add.image(375, 360, 'gameName').setOrigin(0);

    this.playButton.on('pointerover', () => {
      this.playButton.setTexture('play_button_on');
    });

    this.playButton.on('pointerout', () => {
      this.playButton.setTexture('play_button');
    });

    this.playButton.on('pointerdown', () => {
      this.playButton.setAlpha(0);

      this.tweens.add({
        targets: r5,
        alpha: 1,
        duration: 500,
        ease: 'Sine.easeInOut',
      });

      this.time.delayedCall(500, () => {
        disablePointerEvents();
        this.scene.start('GameScene');
        this.scene.stop('StartScene');
      });
    });
  }

  update() {}
}
